import NotificationsIcon from "@mui/icons-material/Notifications";
import AssignmentIcon from "@mui/icons-material/Assignment";
import EventBusyIcon from "@mui/icons-material/EventBusy";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import PaymentsIcon from "@mui/icons-material/Payments";
import BuildCircleIcon from "@mui/icons-material/BuildCircle";

// Icono + color por tipo (mismos "tipo" que arma notificacionesModel.js en el backend).
export const TIPO_CONFIG = {
  "Solicitud": { icon: AssignmentIcon, bg: "info.light", fg: "info.dark" },
  "Permiso": { icon: EventBusyIcon, bg: "warning.light", fg: "warning.dark" },
  "Permiso aprovado": { icon: EventAvailableIcon, bg: "success.light", fg: "success.dark" },
  "Cheque": { icon: PaymentsIcon, bg: "secondary.light", fg: "secondary.dark" },
  "Requerimiento": { icon: BuildCircleIcon, bg: "primary.light", fg: "primary.dark" },
};
export const TIPO_DEFAULT = { icon: NotificationsIcon, bg: "grey.200", fg: "grey.700" };

export const formatDateTime = (iso) => {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    if (!isNaN(d)) {
      return d.toLocaleString("es-BO", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      });
    }
  } catch {}
  const p = (n) => String(n).padStart(2, "0");
  const d = new Date(iso);
  return isNaN(d)
    ? ""
    : `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()} ${p(
        d.getHours()
      )}:${p(d.getMinutes())}`;
};

// "Hace 5 min", "Hace 2 horas", etc. — para la fecha exacta queda el title (hover).
const plural = (n, singular, pluralWord) => `${n} ${n === 1 ? singular : pluralWord}`;
export const timeAgo = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d)) return "";
  const diffSec = Math.max(0, Math.floor((Date.now() - d.getTime()) / 1000));

  if (diffSec < 10) return "Justo ahora";
  if (diffSec < 60) return `Hace ${diffSec} seg`;

  const diffMin = Math.floor(diffSec / 60);
  if (diffMin < 60) return `Hace ${plural(diffMin, "min", "min")}`;

  const diffHoras = Math.floor(diffMin / 60);
  if (diffHoras < 24) return `Hace ${plural(diffHoras, "hora", "horas")}`;

  const diffDias = Math.floor(diffHoras / 24);
  if (diffDias < 7) return `Hace ${plural(diffDias, "día", "días")}`;

  const diffSemanas = Math.floor(diffDias / 7);
  if (diffSemanas < 5) return `Hace ${plural(diffSemanas, "semana", "semanas")}`;

  const diffMeses = Math.floor(diffDias / 30);
  if (diffMeses < 12) return `Hace ${plural(diffMeses, "mes", "meses")}`;

  const diffAnios = Math.floor(diffDias / 365);
  return `Hace ${plural(diffAnios, "año", "años")}`;
};

// Extrae los mismos campos "primary/usuario/tipo/fecha" que ya usaba el dropdown,
// tolerando los distintos nombres de campo que puede mandar el backend.
export const getNotificationFields = (n) => ({
  primary: n.detalle || n.descripcion || n.mensaje || n.titulo || n.asunto || "Notificación",
  usuario: n.usu || n.usuario || n.user || "",
  tipo: n.tipo || "",
  fecha: n.fecha || n.created_at || n.creado_en || null,
});

// Misma lógica de navegación que ya usaba el dropdown al hacer click en un item.
export const resolveNotificationUrl = (n, navigate) => {
  if (!n?.url) return;
  const url = String(n.url);

  if (/^https?:\/\//i.test(url)) {
    window.open(url, "_blank", "noopener,noreferrer");
    return;
  }
  if (url.startsWith("/")) {
    navigate(url);
    return;
  }
  window.open(url, "_blank", "noopener,noreferrer");
};
